import { render, staticRenderFns } from "./CaptchaFetch.vue?vue&type=template&id=dc021358&scoped=true"
import script from "./CaptchaFetch.vue?vue&type=script&lang=js"
export * from "./CaptchaFetch.vue?vue&type=script&lang=js"
import style0 from "./CaptchaFetch.vue?vue&type=style&index=0&id=dc021358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc021358",
  null
  
)

export default component.exports